import { useCallback, useState } from 'react';

import { IsValidCreateUploadResponse } from '@verantos-dev/types-concepts';

import { createExportCsvData } from '../utils/conceptCsvUtils';

export const useExportValidationResults = ({
  concepts,
  conceptGroupName,
}: {
  concepts?: IsValidCreateUploadResponse[];
  conceptGroupName: string;
}) => {
  const [exporting, setExporting] = useState(false);

  const handleExportAll = useCallback(async () => {
    if (!concepts || concepts.length === 0) return;

    setExporting(true);
    try {
      const { filename, csvContent } = createExportCsvData(concepts, conceptGroupName);

      // Create blob and download
      const blob = new Blob([csvContent], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Export failed', error);
    } finally {
      setExporting(false);
    }
  }, [concepts, conceptGroupName]);

  return { exporting, handleExportAll };
};
